<template>

  <el-main :style="{backgroundImage: bingImage, backgroundPosition: 'center', backgroundSize: 'cover'}">

    <!--搜索框-->
    <el-input v-model="searchContent" ref="searchContent" @keypress.enter.native="search" @input="suggestion" class="search" placeholder="请输入搜索内容">
      <!--左侧搜索引擎-->
      <el-dropdown slot="prepend" trigger="click" placement="bottom" style="display: block">
        <el-image :src="searchEngine.img" :alt="searchEngine.name" style="width: 3vh; height: 3vh; display: block" />
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item v-for="engine in searchEngines" :key="engine.name" @click.native="switchSearchEngine(engine)">
            <el-image :src="engine.img" :alt="engine.name" style="width: 3vh; height: 5vh; display: block" />
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <!--右侧功能按钮-->
      <i slot="suffix" class="el-input__icon el-icon-search icon-hover" @click="search"/>
      <i slot="suffix" class="el-input__icon el-icon-s-grid icon-hover" @click="switchEditMode"/>
      <i slot="suffix" class="el-input__icon el-icon-user-solid icon-hover" @click="user"/>
    </el-input>
    <!--搜索建议的位置要和搜索框的位置一样，高度也要一样，宽度无所谓-->
    <el-dropdown trigger="click" placement="bottom" ref="searchSuggestion" @command="search" class="search" style="width: 1px; height: 52px;">
      <!--需要有个东西占位，要不然不显示，这里的宽度要和搜索框的宽度一致-->
      <div></div>
      <el-dropdown-menu slot="dropdown" style="width: 760px">
        <el-dropdown-item v-for="suggestion in searchSuggestions" :command="suggestion" :key="suggestion">
          {{suggestion}}
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>

    <!--蒙层（全屏）-->
    <div class="overlay" :hidden="editMode"></div>

    <!--导航列表（开始是每一行一个el-row，但实现拖动效果非常麻烦，所以后来改成一个统一的el-row，通过el-col的:span来控制每行显示多少个）-->
    <el-row :gutter="10">
      <draggable v-model="navigations" :disabled="!editMode" animation="500" @end="sort">
        <el-col :span="2" v-for="navigation in navigations" :key="navigation.key">
          <el-tooltip effect="light" :open-delay="200" placement="top" :enterable="false" :content="navigation.name" :disabled="!navigation.nid || editMode || !nameTip">
            <a class="logo-wall" draggable="false" :href="navigation.url" :target="linkTarget" @click="edit">
              <!-- 最后换成el-image主要是因为最开始使用image+el-avatar（作为文字图片）但el-avatar的高度总撑不起来，然后换成了只使用image（根据导航判断显示哪张图片，文字图片使用10张纯色作为背景图）然后高度撑起来了，但是文字和图片不是一个整体，最后换成了el-image+错误图+占位图的形式 -->
              <!-- 使用image的问题是正常的图片没问题，但是当使用文字图标时，设置纯色图片为背景图时文字和图片不是一个整体（包括晃动和悬浮都有问题）-->
              <!-- 使用el-avatar的问题是不加src时高度不够，加了src后高度又太高（按照实际图片高度显示的）这也说明了另外一个问题，就是图片太高太大了，需要缩小，且还要减少图片上传大小限制，要不然加载会很慢，更会浪费带宽成本 -->
              <!-- 使用el-image的问题是不显示中间文字，然后也没有了高亮放大效果【这个使用error的方式解决了，而且可以很方便加占位，而且编辑的时候也不会把占位图带过去】 -->
              <!-- 使用el-image时候边框#f0c78a在白色背景下还挺好看 -->
              <el-image
                draggable="false"
                class="logo"
                :src="navigation.icon ? navigation.icon : ''"
                :alt="navigation.name"
                :data-coordinate="navigation.coordinate"
                :data-name="navigation.name"
                :data-url="navigation.url"
                :data-nid="navigation.nid"
                :data-shared="navigation.shared"
                @mouseover="highlightLogo"
                @mouseout="removeHighlight">
                <!-- 占位图是为了防止网络情况差或者图片资源大的时候一直等图片的情况，占位图没有鼠标的移入移出事件，需要单独绑定 -->
                <!-- 这里无信息时只能隐藏，不能用v-if要不然抖动和取消抖动都有问题 在el-image中设置对这里不生效 -->
                <div
                  slot="placeholder"
                  :data-coordinate="navigation.coordinate"
                  :data-name="navigation.name"
                  :data-url="navigation.url"
                  :data-nid="navigation.nid"
                  :data-shared="navigation.shared"
                  :style="{paddingTop: '100%', backgroundColor: '#f5f7fa', visibility: (!navigation.nid && !editMode) ? 'hidden' : 'visible'}"
                  @mouseover="highlightLogo"
                  @mouseout="removeHighlight">
                  <span v-if="navigation.nid" class="logo-placeholder">
                    {{navigation.name}}
                  </span>
                  <i v-else class="el-icon-plus logo-placeholder" style="font-size: xx-large" />
                </div>
                <!-- 错误图是用来作为文字图片使用的，错误图没有鼠标的移入移出事件，需要单独绑定 -->
                <!-- 这里无信息时只能隐藏，不能用v-if要不然抖动和取消抖动都有问题 在el-image中设置对这里不生效 -->
                <div
                  slot="error"
                  :data-coordinate="navigation.coordinate"
                  :data-name="navigation.name"
                  :data-url="navigation.url"
                  :data-nid="navigation.nid"
                  :data-shared="navigation.shared"
                  :style="{paddingTop: '100%', backgroundColor: '#f5f7fa', visibility: (!navigation.nid && !editMode) ? 'hidden' : 'visible'}"
                  @mouseover="highlightLogo"
                  @mouseout="removeHighlight">
                  <span v-if="navigation.nid" class="logo-placeholder">
                    {{navigation.name}}
                  </span>
                  <i v-else class="el-icon-plus logo-placeholder" style="font-size: xx-large" />
                </div>
              </el-image>
            </a>
          </el-tooltip>
        </el-col>
      </draggable>
    </el-row>

    <el-dialog title="编辑网址导航" :visible.sync="dialogFormVisible" :close-on-click-modal="false" top="0">
      <el-form :model="navigation">
        <el-form-item label="模版" :required="true" :label-width="formLabelWidth" style="display: none">
          <el-input v-model="navigation.unid" disabled="disabled" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="坐标" :required="true" :label-width="formLabelWidth">
          <el-input v-model="navigation.coordinate" disabled="disabled" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="网址" :required="true" :label-width="formLabelWidth">
          <el-autocomplete
            class="inline-input"
            :maxlength="300"
            show-word-limit
            placeholder="请输入300以内字符的连接地址（输入后会推荐相似网址）"
            v-model="navigation.url"
            :fetch-suggestions="querySearch"
            :trigger-on-focus="false"
            @select="handleSelect"
            style="width: 100%">
            <div slot-scope="{ item }" class="suggestion-item">
              <el-avatar shape="square" size="medium" :src="item.icon" :alt="item.name">{{item.name}}</el-avatar>
              <span>【{{ item.name }}】（{{ item.url }}）</span>
            </div>
          </el-autocomplete>
        </el-form-item>
        <el-form-item label="名称" :required="true" :label-width="formLabelWidth">
          <el-input v-model="navigation.name" autocomplete="off" minlength="2" maxlength="10" show-word-limit placeholder="请输入2-10个字符的网站名称（建议不超过4个汉字）"></el-input>
        </el-form-item>
        <el-form-item label="分享" :label-width="formLabelWidth">
          <span slot="label">
            <el-tooltip>
              <span slot="content">开启分享的网址导航会在其他用户输入相似地址时推荐给对方<br/>且你在导航列表中将其删除后对方也可以正常使用</span>
              <i class='el-icon-question'></i>
            </el-tooltip>
            分享
          </span>
          <el-switch v-model="navigation.shared"></el-switch>
          <span v-if="publicEditor" style="margin-left: 50px">公共编辑：</span>
          <el-switch v-if="publicEditor" v-model="publicEdit"></el-switch>
        </el-form-item>
        <el-form-item label="图标" :label-width="formLabelWidth">
          <el-input v-model="navigation.icon" autocomplete="off" maxlength="300" show-word-limit placeholder="请上传或输入图标地址（200像素内的正方形图片，大小不超过100KB）"></el-input>
          <el-image
            class="edit-icon"
            :src="navigation.icon"
            :alt="navigation.name">
            <div slot="error"></div>
          </el-image>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="danger" @click="remove" style="float: left">删 除</el-button>
        <el-upload action="" :show-file-list="false" :before-upload="uploadEditIcon" style="display: inline-block">
          <el-button type="primary" plain>上传图标</el-button>
        </el-upload>
        <el-button type="warning" @click="clearEditIcon" plain>文字图标</el-button>
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="save">保 存</el-button>
      </div>
    </el-dialog>

    <!-- 选择图片的时候要限制选择最大宽高在500px以内的 -->
    <el-dialog class="cropper-icon" title="剪裁图标" :visible.sync="dialogIconVisible" :close-on-click-modal="false">
      <el-alert
        title="可以通过鼠标滚轮或触控面板对图片进行缩放"
        :closable="false"
        type="success"
        effect="dark" />
      <br>
      <vueCropper
        ref="cropper"
        style="width: 400px;height: 400px"
        :high="false"
        :original="true"
        :infoTrue="true"
        :autoCrop="true"
        :autoCropWidth="200"
        :autoCropHeight="200"
        :fixedBox="true"
        :fixed="true"
        :canMove="false"
        :centerBox="true"
        :img="cropperImg"
        :outputType="'png'">
      </vueCropper>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogIconVisible = false">取 消</el-button>
        <el-button type="primary" @click="imageCropper">确 定</el-button>
      </div>
    </el-dialog>

  </el-main>

</template>

<script>
import draggable from 'vuedraggable'
import {jsonp, VueJsonp} from 'vue-jsonp'
import VueCropper from '@/vue-cropper/vue-cropper.vue'
export default {
  name: 'Index',
  components: {
    draggable,
    VueJsonp,
    VueCropper
  },
  data () {
    return {
      searchContent: '', // 搜索内容
      searchEngine: null, // 选中的搜索引擎
      searchEngines: [ // 搜索引擎列表
        {
          name: '网湖导航-百度搜索',
          url: 'https://www.baidu.com/s?wd=',
          img: require('@/assets/baidu.svg')
        },
        {
          name: '网湖导航-必应搜索',
          url: 'https://cn.bing.com/search?q=',
          img: require('@/assets/bing.svg')
        },
        {
          name: '网湖导航-谷歌搜索',
          url: 'https://www.google.com/search?q=',
          img: require('@/assets/google.svg')
        },
        {
          name: '网湖导航-站内搜索',
          url: 'http://www.apidock.cn/nav/list?q=',
          img: require('@/assets/apidock.svg')
        }
      ],
      searchSuggestions: [], // 返回的搜索建议列表
      navigations: [], // 导航列表
      coordinates: [], // 用于拖拽排序后重新设置元素的coordinate
      editMode: false,
      // 编辑导航信息
      dialogFormVisible: false,
      dialogIconVisible: false,
      navigation: {
        unid: '',
        nid: '',
        coordinate: '',
        icon: '',
        url: '',
        name: '',
        shared: true
      },
      cropperImg: '',
      linkTarget: '_blank',
      nameTip: true,
      bingImage: '',
      publicEditor: false, // 是否允许公共编辑
      publicEdit: false, // 是否为公共编辑
      formLabelWidth: '80px'
    }
  },
  created: function () {
    this.$http.defaults.baseURL = process.env.VUE_APP_BASE_API
    this.switchSearchEngine(null)
    this.getList()
  },
  mounted: function () {
    let _this = this
    _this.$refs.searchContent.focus()
    window.baiduSuggestionCallBack = function (response) {
      if (response.s && response.s.length > 0) {
        _this.searchSuggestions = response.s
        _this.$refs.searchSuggestion.show()
      } else {
        _this.$refs.searchSuggestion.hide()
      }
    }
  },
  methods: {
    // 高亮并放大显示Logo的函数
    highlightLogo (event) {
      // event.target.classList.add('highlight') // 给当前高亮的Logo添加高亮样式 (使用原生image的模式)
      event.target.parentElement.classList.add('highlight') // 给当前高亮的Logo添加高亮样式 (使用el-image的模式)
    },
    // 移除高亮和放大显示的函数
    removeHighlight (event) {
      // event.target.classList.remove('highlight') // 移除当前Logo的高亮样式，恢复原始大小和样式(使用原生image的模式)
      event.target.parentElement.classList.remove('highlight') // 移除当前Logo的高亮样式，恢复原始大小和样式(使用el-image的模式)
    },
    getList () {
      let navigationDate = localStorage.getItem('navigationDate') // 获取缓存数据日期
      let navigationList = localStorage.getItem('navigationList') // 获取缓存数据列表
      if (navigationList !== null && navigationDate !== null && parseInt(navigationDate) === (new Date()).getDate()) {
        this.handleList(JSON.parse(navigationList), false)
        return
      }
      this.$http.get('navigation/list', {
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('token')
        }
      }).then((response) => {
        if (response.data.code !== 0) {
          this.$message({message: '获取数据失败', type: 'error'})
        } else {
          this.handleList(response.data.data)
        }
      })
    },
    handleList (data, doCache = true) {
      if (Object.keys(data).length === 0) {
        return
      }
      this.navigation.unid = data.unid
      this.linkTarget = data.link_target
      this.nameTip = data.name_tip
      this.bingImage = 'url(' + data.bing_image + ')'
      this.publicEditor = data.public_editor === true
      this.navigations = data.navigations
      this.coordinates = data.navigations.map(navigation => navigation.coordinate)
      if (doCache && data.navigations.length > 0) {
        localStorage.setItem('navigationDate', (new Date()).getDate()) // 设置缓存数据日期
        localStorage.setItem('navigationList', JSON.stringify(data)) // 设置缓存数据列表
      }
    },
    search (content) {
      if (typeof content === 'string') { // 通过搜索推荐点击的
        this.searchContent = content
      }
      if (this.searchEngine === null || this.searchContent.length === 0) {
        return
      }
      if (this.searchContent === ':clearCache') {
        localStorage.removeItem('navigationList')
        this.$message({message: '清理缓存成功', type: 'success'})
        return
      }
      window.location.href = this.searchEngine.url + this.searchContent
    },
    suggestion () {
      if (this.searchContent.length === 0) {
        this.$refs.searchSuggestion.hide()
        return
      }
      // 每次调用都会报如下的warning（看了下其他的站点使用百度建议也都有这个问题，先不管了）
      // Third-party cookie will be blocked in future Chrome versions as part of Privacy Sandbox.
      // 需要把catch加上，要不然会报如下的error（不用带then，带着也收不到数据）
      // index.esm.js:10 Uncaught (in promise) {statusText: 'Request Timeout', status: 408}
      jsonp('https://suggestion.baidu.com/su', {
        callbackQuery: 'cb',
        callbackName: 'window.baiduSuggestionCallBack',
        wd: this.searchContent
      }).catch(() => {})
    },
    switchSearchEngine (engine) {
      // 切换搜索引擎时需要重新设置缓存信息
      if (engine !== null) {
        this.searchEngine = engine
        localStorage.setItem('searchEngine', JSON.stringify(engine))
        return
      }
      // 如果缓存中有信息则直接使用缓存信息
      engine = localStorage.getItem('searchEngine')
      if (engine !== null) {
        this.searchEngine = JSON.parse(engine)
        return
      }
      // 如果缓存中没有信息则使用列表中的第一个并设置缓存
      this.searchEngine = this.searchEngines[0]
      localStorage.setItem('searchEngine', JSON.stringify(this.searchEngine))
    },
    switchEditMode (event) {
      this.editMode = !this.editMode
      // 开启或关闭编辑时添加或移除抖动样式
      if (this.editMode) {
        event.target.classList.add('icon_hover')
        this.$el.querySelectorAll('.logo').forEach(function (logo, index) {
          let shakeClass = 'shake' + (index % 5)
          logo.classList.add(shakeClass)
        })
      } else {
        event.target.classList.remove('icon_hover')
        this.$el.querySelectorAll('.logo').forEach(function (logo, index) {
          let shakeClass = 'shake' + (index % 5)
          logo.classList.remove(shakeClass)
        })
      }
    },
    edit (event) {
      if (!this.editMode) {
        return
      }
      event.preventDefault()
      this.navigation.nid = event.target.dataset.nid
      this.navigation.coordinate = event.target.dataset.coordinate
      this.navigation.name = this.navigation.nid ? event.target.dataset.name : ''
      this.navigation.url = this.navigation.nid ? event.target.dataset.url : ''
      this.navigation.icon = this.navigation.nid ? event.target.src : ''
      this.navigation.shared = this.navigation.nid ? (event.target.dataset.shared === 'true') : true
      this.dialogFormVisible = true
    },
    save () {
      this.dialogFormVisible = false
      this.$http.post('navigation/save', this.navigation, {
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('token')
        }
      }).then((response) => {
        this.handleResponse(response, '导航保存成功')
      })
    },
    sort () {
      let sort = {}
      for (let index in this.navigations) {
        this.navigations[index].coordinate = this.coordinates[index]
        sort[this.coordinates[index]] = this.navigations[index].nid
      }
      this.$http.post('navigation/sort', {
        unid: this.navigation.unid,
        sort: sort
      }, {
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('token')
        }
      }).then((response) => {
        this.handleResponse(response, '顺序保存成功')
      })
    },
    remove () {
      this.dialogFormVisible = false
      this.$http.post('navigation/remove', {
        unid: this.navigation.unid,
        nid: this.navigation.nid,
        coordinate: this.navigation.coordinate
      }, {
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('token')
        }
      }).then((response) => {
        this.handleResponse(response, '删除成功')
      })
    },
    handleResponse (response, message = '操作成功') {
      if (response.data.code === 80003) {
        localStorage.clear()
        window.location.href = '/login'
      } else if (response.data.code === 80005) {
        this.$message({message: response.data.data[Object.keys(response.data.data)[0]][0], type: 'error'})
      } else if (response.data.code !== 0) {
        this.$message({message: response.data.msg, type: 'error'})
      } else {
        this.handleList(response.data.data)
        this.$message({message: message, type: 'success'})
      }
    },
    querySearch (queryString, cb) {
      this.$http.get('navigation/like?url=' + queryString, {
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('token')
        }
      }).then((response) => {
        if (response.data.code === 0 && response.data.data) {
          cb(response.data.data)
        }
      })
    },
    handleSelect (ev) {
      this.navigation.nid = ev.nid
      this.navigation.name = ev.name
      this.navigation.url = ev.url
      this.navigation.icon = ev.icon
      this.navigation.shared = true
    },
    clearEditIcon () {
      this.navigation.icon = ''
    },
    uploadEditIcon (file) {
      this.dialogIconVisible = true
      this.cropperImg = window.URL.createObjectURL(file)
      return false
    },
    imageCropper () {
      this.$refs.cropper.getCropBlob(data => {
        if (data.size > 102400) { // 截取后图片宽高固定是200px（不用校验），如果文件大小超过了100KB就不要上传了，要不然上传完也通不过验证
          this.$message({message: '截取后的图片大小不能大于100KB，建议对原图调小尺寸或压缩后再进行截取', type: 'error'})
          return
        }
        this.$http.get('aliyun/oss/policy/get?public_edit=' + this.publicEdit, {headers: {Authorization: 'Bearer ' + localStorage.getItem('token')}}).then((response) => {
          if (response.data.code !== 0 || !response.data.data) {
            this.$message({message: '获取上传凭证失败', type: 'success'})
            return
          }
          let filename = response.data.data['time'] + '.' + data.type.replace('image/', '')
          let file = new File([data], filename, {type: data.type, lastModified: Date.now()})
          let fromData = new FormData()
          fromData.set('key', response.data.data['key'] + filename) // 这个必须放上面
          for (let key in response.data.data) {
            if (key === 'OSSAccessKeyId' || key === 'policy' || key === 'signature' || key === 'callback') {
              fromData.set(key, response.data.data[key])
            }
          }
          fromData.set('file', file) // 这个必须放下面
          this.$http.post(response.data.data['host'], fromData, {headers: {'Content-Type': 'multipart/form-data'}}).then((uploaded) => {
            this.navigation.icon = uploaded.data.code === 0 ? uploaded.data.data.url : (response.data.data['cdnDomain'] + '/' + fromData.get('key'))
          })
        })
        this.dialogIconVisible = false
      })
    },
    user () {
      window.location.href = '/user'
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.el-main {
  /* background: #0b0e16; */
  background-color: #555555;
  padding: 10px;
  text-align: center;
  overflow: hidden;
  height: 100vh;
  display: flex;
  justify-content: center;
  flex-direction: column;
}

/* 整体输入框的样式 */
.search {
  width: 760px;
  height: 52px;
  font-size: large;
  z-index: 300;
  position: fixed;  /* 相对于浏览器窗口定位 */
  top: 20%;
  left:0;
  right: 0;
  margin: auto;
}

/* 实际输入框的高度和圆角 */
/deep/ .search .el-input__inner {
  height: 52px;
  border-radius: 0 24px 24px 0;
}

/* 输入框左边的圆角 */
/deep/ .search .el-input-group__prepend {
  border-radius: 24px 0 0 24px;
}

/* 弹窗居中 */
/deep/ .el-dialog {
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  margin: 0 !important;
}

/* Logo行间距 */
.el-col {
  margin-top: 1.5vh;
  margin-bottom: 1.5vh;
}

/* 编辑中的开关一直居中（继承的是.el-main的居中） */
/deep/ .el-form-item__content {
  text-align: left;
}

/* 网址导航建议列表的样式 */
.suggestion-item {
  display: flex;
  align-items: center;
  padding-top: 5px;
  padding-bottom: 5px;
}

/* Logo墙的样式（如果注释掉就没有高亮效果了） */
.logo-wall {
  display: grid;
  /* 下面这个样式如果打开当浏览器变小的时候图片没有自适应 */
  /* grid-template-columns: repeat(auto-fill, minmax(100px, 1fr)); */
  gap: 10px;
  position: relative;
}

/* Logo的样式 */
.logo {
  width: 100%;
  height: auto;
  transition: transform 0.3s ease-in-out; /* 放大时的动画效果 */
  border-radius: 3.5vh;
  aspect-ratio: 1/1; /* 宽高比1:1使其成为正方形，兼容性很差 */

  /*object-fit: cover;*/
  /*mix-blend-mode: darken;*/
  /*border-radius:10px;*/
  /*box-shadow:0 0 50px black, 0 0 100px black, 0 0 105px black*/
}

/* Logo占位图和无Logo时的样式 */
.logo-placeholder {
  pointer-events: none; /* 这个是为了让文字不接受事件，要不然悬浮高亮会有问题 */
  white-space: nowrap;
  overflow: hidden;
  font-size:x-large;
  color: #f0c78a;
  /* 这里解决了文字居中问题，感谢文心一言 */
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

/* 蒙层的样式 */
.overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.2); /* 黑色半透明背景 */
  z-index: 9;
  pointer-events: none;
  opacity: 1;
  transition: opacity 0.3s ease-in-out; /* 蒙层出现和消失的动画效果 */
}

/* 导航Logo高亮并放大显示的样式 */
.highlight {
  transform: scale(1.05); /* 放大倍数可以根据需要进行调整 */
  z-index: 200;
}

/* 搜索框里面的功能按钮鼠标悬停放大高亮 */
.icon-hover:hover, .icon_hover {
  color: #409EFF;
  transform: scale(1.2)
}

/* 编辑导航地址预览图标的边框 */
.edit-icon {
  width: 100px;
  height: 100px;
  line-height: 100px;
  font-size: 30px;
  border: 1px solid #DCDFE6;
  border-radius: 3.3vh;
}

/* 编辑导航时的抖动效果，最开始只定义一个动画，所有导航图标的运动规律都是一样的，看起来非常别扭，所以需要实现多个图标随机抖动的效果 */
/* 第一种办法是一个动画，点击编辑按钮不同的导航图标的起始时间不同，但是这种排在后面的导航图标要等很久才能动起来，效果很差 */
/* 第二种就是当前使用的办法，定义多个动画，遍历导航图标时按照索引使用对应的动画，这样动画个数越多，效果越好，目前定义的是5个动画效果 */
/* ================================= */
@keyframes shake0 {
  0% { transform: translate(0, 0); }
  25% { transform: translate(-1px, 2px); }
  50% { transform: translate(1px, -2px); }
  75% { transform: translate(2px, -1px); }
  100% { transform: translate(-2px, 1px); }
}
.shake0 {
  display: inline-block;
  animation: shake0 0.5s;
  animation-iteration-count: infinite;
}
/* --------------------------------- */
@keyframes shake1 {
  0% { transform: translate(0, 0); }
  25% { transform: translate(2px, -1px); }
  50% { transform: translate(-2px, 1px); }
  75% { transform: translate(-1px, 2px); }
  100% { transform: translate(1px, -2px); }
}
.shake1 {
  display: inline-block;
  animation: shake1 0.7s;
  animation-iteration-count: infinite;
}
/* --------------------------------- */
@keyframes shake2 {
  0% { transform: translate(0, 0); }
  25% { transform: translate(-2px, 1px); }
  50% { transform: translate(2px, -1px); }
  75% { transform: translate(-1px, 2px); }
  100% { transform: translate(1px, -2px); }
}
.shake2 {
  display: inline-block;
  animation: shake2 0.6s;
  animation-iteration-count: infinite;
}
/* --------------------------------- */
@keyframes shake3 {
  0% { transform: translate(0, 0); }
  25% { transform: translate(1px, -2px); }
  50% { transform: translate(-2px, 1px); }
  75% { transform: translate(-1px, 2px); }
  100% { transform: translate(2px, -1px); }
}
.shake3 {
  display: inline-block;
  animation: shake3 0.8s;
  animation-iteration-count: infinite;
}
/* --------------------------------- */
@keyframes shake4 {
  0% { transform: translate(0, 0); }
  25% { transform: translate(2px, -1px); }
  50% { transform: translate(1px, -2px); }
  75% { transform: translate(-2px, 1px); }
  100% { transform: translate(-1px, 2px); }
}
.shake4 {
  display: inline-block;
  animation: shake4 0.3s;
  animation-iteration-count: infinite;
}
/* ================================= */

</style>



// WEBPACK FOOTER //
// src/components/Index.vue